import { deviceToken } from 'lib/reactiveVariables'

import { AuthenticationLayout } from '@/components/authentication/auth_layout'
import { MobileSwitch } from '@/components/ui'
import { exists } from '@/utils/index'
import { SignIn, useSignIn } from '@clerk/clerk-react'
import { useRouter } from 'next/router'
import { is, isEmpty } from 'ramda'
import { ReactElement, useEffect, useState } from 'react'

import Layout from 'components/layout'

const SignInPage = () => {
  const { query } = useRouter()

  const [redirectURL, setRedirectURL] = useState<string>()

  useEffect(() => {
    if (exists(query.redirectURL)) {
      setRedirectURL(String(query.redirectURL))
    } else {
      let _redirectURL = sessionStorage.getItem('redirectURL')
      if (_redirectURL) {
        setRedirectURL(_redirectURL)
      }
    }
  }, [query.redirectURL])

  useEffect(() => {
    if (redirectURL) {
      sessionStorage.setItem('redirectURL', redirectURL)
    }
  }, [redirectURL])

  useEffect(() => {
    if (is(String, query.deviceToken) && !isEmpty(query.deviceToken)) {
      deviceToken(query.deviceToken)
    }
  }, [query.deviceToken])

  const isLocal = window.location.href.startsWith('http://localhost:3000')
  const isStaging = window.location.href.startsWith('https://staging.belong.ly')

  const hostName = isLocal
    ? 'http://localhost:3000'
    : isStaging
    ? 'https://staging.belong.ly'
    : 'https://my.belong.ly'

  return (
    <AuthenticationLayout>
      <MobileSwitch
        regularView={
          <SignIn
            appearance={{
              variables: {
                colorPrimary: '#3F377A',
              },

              elements: {
                rootBox: 'flex',
                card: 'flex bg-white border-[2px] rounded shadow-none border-gray-light',
                headerTitle:
                  'after:content-["_to_continue_to_your_belongly_account"]  text-gray-mid font-extralight text-sm',
                headerSubtitle: 'hidden',
                formFieldLabel: 'text-gray-mid',
                formFieldInput:
                  'w-full px-4 align-center rounded grow outline-none focus:outline-0 focus:border-none py-[14.5px] bg-background',
                formButtonPrimary:
                  'w-full py-5 px-8 text-xs rounded-md capitalize',
                footer: 'flex w-full justify-center items-center',
                footerActionLink: 'text-[#798DCF] text-md',
                footerActionText: 'text-gray-mid text-md',
              },
            }}
            redirectUrl={redirectURL ? `${hostName}${redirectURL}` : null}
            path="/sign-in"
            routing="path"
            signUpUrl="https://www.belongly.com/start/"
          />
        }
        mobileClassName="flex w-full"
        mobileView={
          <SignIn
            appearance={{
              variables: {
                colorPrimary: '#3F377A',
              },

              elements: {
                rootBox: 'flex w-full justify-center mx-0',
                card: 'flex w-full mx-0 bg-white border-[2px] rounded shadow-none border-gray-light',
                headerTitle:
                  'after:content-["_to_continue_to_your_belongly_account"]  text-gray-mid font-extralight text-sm',
                headerSubtitle: 'hidden',
                formFieldLabel: 'text-gray-mid',
                formFieldInput:
                  'w-full px-4 align-center rounded grow outline-none focus:outline-0 focus:border-none py-[14.5px] bg-background',
                formButtonPrimary:
                  'w-full py-5 px-8 text-xs rounded-md capitalize',
                footer: 'flex w-full justify-center items-center',
                footerActionLink: 'text-[#798DCF] text-md',
                footerActionText: 'text-gray-mid text-md',
              },
            }}
            redirectUrl={redirectURL ? `${hostName}${redirectURL}` : null}
            path="/sign-in"
            routing="path"
            signUpUrl="https://www.belongly.com/start/"
          />
        }
      />
    </AuthenticationLayout>
  )
}

SignInPage.getLayout = (page: ReactElement) => {
  return <Layout isWithoutBorder>{page}</Layout>
}

export default SignInPage
